import { Injectable } from '@angular/core';

import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { ConfigService } from '../shared/config.service';
import { Programmehebdo } from '../model/programmehebdo.model';
import { ActiviteProgramhebdo } from '../model/activiteprogramhebdo.model';

@Injectable()
export class ProgrammehebdoService {

  _baseUrl: string ='';

  constructor(private http: Http,
              private configService: ConfigService) { 

        this._baseUrl = configService.getApiURI();
  }

  getByActivite(id: string): Observable<Programmehebdo[]> {
    let cpHeaders = new Headers({ 'Content-Type': 'application/json' });
    let cpParams = new URLSearchParams();
    cpParams.set('id', id);	
    let options = new RequestOptions({ headers: cpHeaders, params: cpParams });
    return this.http.get(this._baseUrl + 'programmhebdo/getByActivite', options)
        .map((res: Response) => {
                     // console.log(res.json());
          return res.json();
        })
        .catch(this.handleError);
  }

  get(id: string) : Observable<Programmehebdo> {
    let cpHeaders = new Headers({ 'Content-Type': 'application/json' });
    let cpParams = new URLSearchParams();
    cpParams.set('id', id);	
    let options = new RequestOptions({ headers: cpHeaders, params: cpParams });
    return this.http.get(this._baseUrl + 'programmhebdo/get', options)
          .map((res: Response) => {
     // console.log(res.json());
              return res.json();
          })
          .catch(this.handleError);

  }

  create(programmehebdo: Programmehebdo) {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

      return this.http.post(this._baseUrl + 'programmhebdo/create', programmehebdo, options)
            .map((res: Response) => {
                
            })
            .catch(this.handleError);
  }


  createmultiple(activiteProgramhebdo: ActiviteProgramhebdo) {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

      return this.http.post(this._baseUrl + 'programmhebdo/createmultiple', activiteProgramhebdo, options)
            .map((res: Response) => {
                
            })
            .catch(this.handleError);
  }


  update(programmehebdo: Programmehebdo) {
    let  headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
      return this.http.put(this._baseUrl + 'programmhebdo/update', programmehebdo, options)
            .map((res: Response) =>{
                return res.json();
            })
            .catch(this.handleError);
  }

  delete(id: string) {
    let cpHeaders = new Headers({ 'Content-Type': 'application/json' });
    let cpParams = new URLSearchParams();
    cpParams.set('id', id);			
    let options = new RequestOptions({ headers: cpHeaders, params: cpParams });

    //console.log(options.params);
    return this.http.delete(this._baseUrl + 'programmhebdo/delete', options)
            .map(success => success.status)
            .catch(this.handleError);

  }




  private handleError(error: any) {
    var applicationError = error.headers.get('Application-Error');
    var serverError = error.json();
    var modelStateErrors: string = '';

    if (!serverError.type) {
        // console.log(serverError);
        for (var key in serverError) {
            if (serverError[key])
                modelStateErrors += serverError[key] + '\n';
        }
    }

    modelStateErrors = modelStateErrors = '' ? null : modelStateErrors;

    return Observable.throw(applicationError || modelStateErrors || 'Server error');
  }

}



// WEBPACK FOOTER //
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/service/programmehebdo.service.ts